import React, { useMemo, useEffect } from "react";
import { Box, Button, Flex } from "@chakra-ui/react";
import { primary, white } from "../../utils/colors";
import useThemeColors from "../../hooks/useThemeColors";

const TeethPopoverNew = ({
  initialTeeth,
  handleToothClick,
  selectedTeeth,
  setSelectedTeeth,
  toothMinW,
  toothH,
  lineW,
  lineH,
  tpStatus,
}) => {
  const { newBorderMode, textPrimaryButtonMode } = useThemeColors();

  const renderTeeth = useMemo(() => {
    const upperLeftTeeth = Array.from({ length: 8 }, (_, i) => 18 - i);
    const upperRightTeeth = Array.from({ length: 8 }, (_, i) => 21 + i);
    const lowerLeftTeeth = Array.from({ length: 8 }, (_, i) => 48 - i);
    const lowerRightTeeth = Array.from({ length: 8 }, (_, i) => 31 + i);

    const renderTeethButtons = (teethNumbers) =>
      teethNumbers.map((toothNumber) => (
        <Button
          key={toothNumber}
          colorScheme={selectedTeeth.includes(toothNumber) ? "blue" : "gray"}
          onClick={(e) => handleToothClick(toothNumber, e)}
          m={0}
          size="md"
          fontSize="0.8rem"
          p={0}
          bg={
            selectedTeeth.includes(toothNumber) ? textPrimaryButtonMode : "none"
          }
          borderRadius="0.5rem"
          minWidth={toothMinW || "26px"}
          h={toothH || "32px"}
          color={selectedTeeth.includes(toothNumber) ? white : "#DFDFDF"}
          _hover={{ bg: primary, color: white }}
          isDisabled={
            tpStatus === "cancelled" ||
            tpStatus === "completed" ||
            tpStatus === "approved" ||
            tpStatus === "ongoing"
          }
        >
          {toothNumber}
        </Button>
      ));

    return {
      upperLeftTeeth: renderTeethButtons(upperLeftTeeth),
      upperRightTeeth: renderTeethButtons(upperRightTeeth),
      lowerLeftTeeth: renderTeethButtons(lowerLeftTeeth),
      lowerRightTeeth: renderTeethButtons(lowerRightTeeth),
    };
  }, [selectedTeeth, handleToothClick]);

  // USE EFFECT
  useEffect(() => {
    let teethNumbers;
    if (Array.isArray(initialTeeth) && initialTeeth.length > 0) {
      // If the first element is a string and contains a comma, we assume it's a comma-separated list.
      if (
        typeof initialTeeth[0] === "string" &&
        initialTeeth[0].includes(",")
      ) {
        teethNumbers = initialTeeth[0].split(",").map(Number);
      } else {
        // Otherwise, we map over the array and convert each string to a number.
        teethNumbers = initialTeeth.map(Number);
      }
    } else {
      // If initialTeeth is not an array, default to an empty array.
      teethNumbers = [];
    }
    setSelectedTeeth(teethNumbers);
  }, [initialTeeth]);

  // LOGS
  // console.log("tpStatus in TeethPopover", tpStatus);

  return (
    <Flex>
      <Flex direction="column">
        <Box display="flex" flexWrap="wrap" p="0.25rem 0">
          {renderTeeth.upperLeftTeeth}
        </Box>
        <Box bg={newBorderMode} w={lineW || "208px"} h="1px" mx={0} />
        <Box display="flex" flexWrap="wrap" p="0.25rem 0">
          {renderTeeth.lowerLeftTeeth}
        </Box>
      </Flex>
      <Box bg={newBorderMode} h={lineH || "80px"} w="1px" mx={2} />
      <Flex direction="column">
        <Box display="flex" flexWrap="wrap" p="0.25rem 0">
          {renderTeeth.upperRightTeeth}
        </Box>
        <Box bg={newBorderMode} w={lineW || "208px"} h="1px" mx={0} />
        <Box display="flex" flexWrap="wrap" p="0.25rem 0">
          {renderTeeth.lowerRightTeeth}
        </Box>
      </Flex>
    </Flex>
  );
};

export default TeethPopoverNew;
